import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PromoBannerComponent } from './promo-banner.component';
import { RouterModule } from '@angular/router';

import { StoreModule } from '@ngrx/store';
import { reducers } from '@app/core/i18n/store/reducers';
import { PromotionsLegalConditionsComponent } from './promotions-legal-conditions/promotions-legal-conditions.component';
import { RefModule } from '@app/shared/components/ref/ref.module';

@NgModule({
  imports: [CommonModule, RouterModule, StoreModule.forFeature('i18n', reducers), RefModule],
  declarations: [PromoBannerComponent, PromotionsLegalConditionsComponent],
  exports: [PromoBannerComponent],
  providers: []
})
export class PromoBannerModule {}
